import React from 'react';
import SuggestionsPage from '../../components/hairstyles/SuggestionsPage';

const HairstyleSuggestions = () => {
  return <SuggestionsPage />;
};

export default HairstyleSuggestions;
